// imports for IE11 compatibility
import 'core-js/es/object';
import 'core-js/es/promise';

import React from 'react';
import ReactDOM from 'react-dom';
import 'react-hot-loader/patch';

import App from './containers/Bootstrap/Bootstrap';
import setupTranslations from './services/translations';
import { getLocaleFromSettings, getLocaleFromGon } from './selectors/selectors';
import { setupAnalytics } from './services/analytics';
import { setupApi } from './services/api';
import setupIcons from './services/icons';
import createTheme from './services/theme';

// Puts the DOM element the React app is mounting to
// into a shared scope
// so that it can be unmounted later
let el = null;

export function init({ element, settings = {} }) {
  el = element;
  const locale =
    getLocaleFromSettings(settings) || getLocaleFromGon(window.gon);

  setupTranslations(locale)
    .then(() => {
      setupAnalytics();
      setupIcons();
    })
    .then(() => {
      const { jwt, idpType } = settings;

      const { origin } = window.location;
      setupApi({
        jwt,
        origin,
        idpType
      }).then(() => {
        // TODO: Remove these fallbacks to window.gon
        // when the monolith is configured to pass
        // the community type and other settings again
        const bootstrapSettings = {
          ...settings,
          communityType: settings.communityType || window.gon.community_type,
          communityId: settings.communityId || window.gon.community_id,
          company: settings.company || window.gon.current_company.name,
          socialFeedShowInput: settings.embedWithInput,
          topicId: window.gon.topic?.id
        };

        const { companyColour = '#ea1d77' } = settings;
        const theme = createTheme({ companyColour });
        const render = (RootComponent) => {
          ReactDOM.render(
            <RootComponent settings={bootstrapSettings} theme={theme} />,
            document.querySelector(element)
          );
        };

        // initial render of root component
        render(App);

        // Hooking up hot module reloading.
        if (module.hot) {
          // TODO: Find a way to dynamically get this path?
          module.hot.accept('./containers/Bootstrap/Bootstrap.jsx', () => {
            import(`./containers/Bootstrap/Bootstrap.jsx`).then(
              ({ default: RootComponent }) => {
                render(RootComponent);
              }
            );
          });
        }
      });
    });
}

export const unmountExistingComponent = () => {
  const element = document.querySelector(el);
  if (element) ReactDOM.unmountComponentAtNode(element);
};

export default init;
